import mixpanel from '@aqx-core/common/mixpanel';

import { eventNameHelper, userHelper } from '../helpers';
import { EMixpanelProperties } from '../types';
import { IMixpanelSignalInterestProps } from './types';

class SignalAnalysisService {
  public signalInterest = ({ action, symbol }: IMixpanelSignalInterestProps) => {
    const userAccountProperties = userHelper.createUserAccountProperties();
    const eventName = eventNameHelper.mapSignalInterestEventName(action);
    mixpanel.track(eventName, {
      [EMixpanelProperties.SYMBOL]: symbol ?? '-',
      ...userAccountProperties
    });
  };
}

const signalAnalysisService = new SignalAnalysisService();
export default signalAnalysisService;
